// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3F1bQ","title":"AfterImages45_title__2jFIh","images":"AfterImages45_images__vhrK3"};